import { useTheme } from '@mui/material/styles';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import Head from '../components/Header/Head';
import Header from '../components/Header/Header';
import { MAPBOX_TOKEN } from '../config';
import withApollo from '../lib/withApollo';

const MapCluster = dynamic(() => import('../components/Maps/MapCluster'), {
  ssr: false,
});

const MapPage = () => {
  const router = useRouter();

  const latitude = Number(router.query.latitude);
  const longitude = Number(router.query.longitude);
  const zoom = Number(router.query.zoom);
  const { search } = router.query;

  const [bbox, setBbox] = useState(undefined);
  const [center, setCenter] = useState(undefined);
  const [posts, setPosts] = useState([]);

  const theme = useTheme();

  useEffect(() => {
    if (search) {
      fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
          search,
        )}.json?limit=1&language=en-GB&access_token=${MAPBOX_TOKEN}`,
      )
        .then(res => {
          return res.json();
        })
        .then(data => {
          if (data && data.features && data.features.length > 0) {
            setBbox(data.features[0].bbox);
            setCenter(data.features[0].center);
          }
        });
    }
    fetch('/api/map-posts')
      .then(res =>
        res.json().then(result => {
          if (result && result.posts) {
            setPosts(result.posts);
          }
        }),
      )
      .catch(err => {
        console.log(err);
      });
  }, []);

  const title = 'Map';

  return (
    <>
      <Header subheader={title} active="map" noChatbot />
      <Head title="Travel Blog Map" includeMapbox />
      <>
        {(search && !center && <></>) || (
          <div
            id="container"
            className="tw-top-0 tw-h-[calc(100vh-7.5rem)] lg:tw-h-[calc(100vh-4rem)]"
          >
            <MapCluster
              data={posts}
              dark={theme.palette.mode === 'dark'}
              latitude={center && center.length > 0 ? center[1] : latitude}
              longitude={center && center.length > 0 ? center[0] : longitude}
              zoom={zoom}
              bbox={bbox}
              getHeightFromContainer
              highlightLat={latitude}
              highlightLon={longitude}
            />
          </div>
        )}
      </>
    </>
  );
};

export default withApollo(MapPage);
